import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { ParamterComponentListControlerComponent } from './parameter-component-list-controler.component';

@NgModule({
  declarations: [ParamterComponentListControlerComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule],
  exports: [ParamterComponentListControlerComponent]
})
export class ParamterComponentListControlerModule {}
